import qs from 'qs';
import { HttpMethods } from '../enums/HttpMethods';
import { DataWrapper } from '../interfaces/DataWrapper';
import { Tag } from '../interfaces/Tag';
import ContentFeedService from './contentFeed.service';
import { TagStatistics } from '../interfaces/TagStatistics';
import { TagTypes } from '../enums/TagTypes';

class TagsService {
  public static getAll(): Promise<Tag[]> {
    return ContentFeedService.sendRequest<DataWrapper<Tag[]>>(HttpMethods.GET, 'tags')
      .then((wrappedTags: DataWrapper<Tag[]>) => wrappedTags.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getByType(type: string): Promise<Tag[]> {
    return ContentFeedService.sendRequest<DataWrapper<Tag[]>>(HttpMethods.GET, `tags?filters[type][$eq]=${type}`)
      .then((wrappedTags: DataWrapper<Tag[]>) => wrappedTags.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getAllTypes(): Promise<string[]> {
    return ContentFeedService.sendRequest<DataWrapper<string[]>>(HttpMethods.GET, 'tags/all-types')
      .then((wrappedTypes: DataWrapper<string[]>) => wrappedTypes.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getByNameAndType(name: string, type: string): Promise<Tag[]> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            { name: { $containsi: name } },
            { type: { $eq: type } },
          ],
        },
      }
    );

    return ContentFeedService.sendRequest<void>(HttpMethods.GET, `tags?${query}`)
      .then((wrappedTags: DataWrapper<Tag[]>) => wrappedTags.data)
      .catch((error: Error) => {
        throw error;
      })
  }

  public static clearNoTagTags(tags: Tag[]): Tag[] {
    return tags.filter(tag => TagTypes.NO_TAG !== tag.attributes.type);
  }

  public static getMostPopularTagsByType(type: string): Promise<Tag[]> {
    return ContentFeedService.sendRequest<void>(HttpMethods.GET, `tags/most-popular/${type}`)
      .then((tags: TagStatistics[]) => {
        return tags.map((tag) => {
          return {
            id: tag.id,
            attributes: {
              name: tag.name,
              type: tag.type,
              tagger_id: tag.tagger_id,
              sport: tag.sport,
              gender: tag.gender
            }
          };
        })
      })
      .catch((error: Error) => {
        throw error;
      })
  }
}

export default TagsService;
